import { render, staticRenderFns } from "./BestJobCalculator.vue?vue&type=template&id=01c5b732&"
import script from "./BestJobCalculator.vue?vue&type=script&lang=js&"
export * from "./BestJobCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports